import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { faImage } from '@fortawesome/pro-light-svg-icons'

import { Box, Columns } from '@domain-group/suit-theme'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import WaterMarkSettings from '../WatermarkSettings'

const PageContent = () => {
  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  return (
    <>
      <Helmet>
        <title>Image Settings | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="image-settings"
        nestedNavigation
        tabBarItems={[
          // @ts-expect-error TS2741
          {
            icon: faImage,
            key: 'image-settings',
            title: 'Image Settings',
          },
        ]}
        title="Image Settings"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.imageSettings.banner" />

            <WaterMarkSettings />
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.imageSettings.sidebar" />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
